var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueFolderXLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M49.166 21.1016H107.306C110.477 21.1016 112.591 23.0914 112.591 26.0761V36.0251H49.166V21.1016Z",
    fill: "#4776E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9378 16.127H12.1682C8.99698 16.127 6.88281 18.1168 6.88281 21.1015V95.7191C6.88281 98.7038 8.99698 100.694 12.1682 100.694H107.306C110.477 100.694 112.591 98.7038 112.591 95.7191V36.025C112.591 33.0403 110.477 31.0505 107.306 31.0505H59.737L51.2803 19.1117C50.2232 17.1219 47.5805 16.127 44.9378 16.127Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFolderXLargeIcon);
export default __webpack_public_path__ + "static/media/blue-folder-X-large-icon.387a219ae2f2d51707374f1ae003cbc1.svg";
export { ForwardRef as ReactComponent };